// removed by extract-text-webpack-plugin
module.exports = {"oy_tag":"oy_tag__2nnKaNU9","small":"small__nktn5MTR","tiny":"tiny__2pFoKOpB","tagText":"tagText__3LE15DyA","icon":"icon__3vUyK96a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYTag/index.module.less
// module id = 748
// module chunks = 1